import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { AppNotificationEvent } from '../models/app-notification-event';

@Component({
    selector: 'app-notification-event-button',
    templateUrl: './app-notification-event-button.component.html',
    styleUrls: ['./app-notification-event-button.component.scss'],
    standalone: false
})
export class AppNotificationEventButtonComponent {


    private _notificationEvent: AppNotificationEvent;
    private _message: string;

    @Input()
    set notificationEvent(n: AppNotificationEvent) {
        this._notificationEvent = n;
    }

    @Input()
    set message(m: string) {
        this._message = m;
    }

    get notificationEvent(): AppNotificationEvent {
        return this._notificationEvent;
    }

    get message(): string {
        return this._message;
    }

    @Output()
    clicked = new EventEmitter<AppNotificationEvent>();

    position = 'below';

    constructor() { }

    eventClick() {
        this.clicked.emit(this._notificationEvent);
    }

    updateToolip(m: string): void {
        this._message = m;
    }
}

